import { Form, Input } from 'antd'
import React from 'react'

const EVerifyMotorForm = () => {
    return (
        <div className="row">
            <div className="col-sm-6 labelSSS">
                <Form.Item
                    name='Policy'
                    label="Policy #"
                    rules={[
                        {
                            required: true,
                            message: "Please Enter Policy Number!"
                        }
                    ]}
                >
                    <Input placeholder='Policy #' />
                </Form.Item>

            </div>
            <div className="col-sm-6 labelSSS">
                <Form.Item
                    name='Engine'
                    label="Engine #"
                    rules={[
                        {
                            required: true,
                            message: "Please Enter Engine Number!"
                        }
                    ]}
                >
                    <Input placeholder='Engine #' />
                </Form.Item>
            </div>

        </div>
    )
}

export default EVerifyMotorForm